export * from "-!../../../../node_modules/babel-loader/lib/index.js!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./bot.spinner.vue?vue&type=template&id=b0a42c58&"


//////////////////
// WEBPACK FOOTER
// ./src/components/bot/spinner/bot.spinner.vue?vue&type=template&id=b0a42c58&
// module id = 714
// module chunks = 0 1 2 3 4 5 6 7 8 11